import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import { initializeLinks } from './links'
import { initializeSlider } from './slider'
import { initializeHistorySlider } from './historySlider'
import { initializePartnerLogos } from './partnerLogos'
import { openModal } from './modalHelper'
import { Observer } from 'tailwindcss-intersect'
import { initializeTabs } from './tabs'
import { initializeProcessLayers } from './processLayers'
import { initializeFacts } from './facts'
import { initializeSectionReveal } from './sectionReveal'
import { initializeNewsArticles } from './newsArticles'
import { initializeNewsTeaser } from './newsTeaser'
import { initializeEvents } from './events'
import { initializeLinkList } from './linkList'
import { initializeLinkListCards } from './linkListCards'
import { initializeJobs } from './jobs'
import { initializeSocialShare } from './socialShare'
import { initializeSvgDraw } from './svgDraw'

Alpine.plugin(collapse)
window.Alpine = Alpine
window.accordionCloseOthers = true

window.openModal = openModal

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
  Observer.start()

  initializeLinks()
  initializeSlider()
  initializeHistorySlider()
  initializePartnerLogos()
  initializeTabs()
  initializeProcessLayers()
  initializeFacts()
  initializeSectionReveal()
  initializeNewsArticles()
  initializeNewsTeaser()
  initializeEvents()
  initializeLinkList()
  initializeLinkListCards()
  initializeJobs()
  initializeSocialShare()
  initializeSvgDraw()
})
